import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-msgsuspeitas',
  templateUrl: './msgsuspeitas.component.html',
  styleUrls: ['./msgsuspeitas.component.scss']
})
export class MsgsuspeitasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
